import {
    getFilters,
    getGroupedFilters,
    removeFilterGroup,
    removeFilterGroupValue,
    removeGroupedFilterGroup,
    setFilterGroupValue,
} from "@modules/azm/filter"
import { afterFilterApiFetched } from "../after-filter-api-fetched"
import { fetchApiWithAllFiltersDebounced } from "../api"
import { getCategories, removeCategory, setCategories } from "../category"
import { filterConfig } from "../filter-config"
import { hideInfoStripe, showInfoStripe } from "../info-stripe"
import { resetPagination } from "../pagination/pagination"
import { updateFilterCategoryCheckboxes } from "./category-checkboxes"
import { createActiveFilterDeleteAllButton, createActiveFilterGroup } from "./filter-bar-elements"
import { updateFilterCheckboxes } from "./filter-checkboxes"
import { updateFilterTabsInDomMobile } from "./filter-tabs"
import { getSearchText, setSearchText } from "./search-text-data"
import { updateSearchTextInDom } from "./searchtext"

export const activeFilterBarContainerElement = () =>
    document.querySelector<HTMLDivElement>(".panel-active-filters .gewaehlte-merkmale")

export function updateActiveFilterBarInDom() {
    const container = document.createDocumentFragment()
    const groupedFilters = getGroupedFilters()
    const categories = getCategories()

    if (!SiteInfo.filterGroupOrder) {
        SiteInfo.filterGroupOrder = Object.keys(groupedFilters)
    }

    requestAnimationFrame(() => {
        // filters
        for (const displayGroup of SiteInfo.filterGroupOrder) {
            if (displayGroup === "Rubrik" && categories.length > 0) {
                container.appendChild(createActiveFilterGroup("rubrik", "Rubrik:", categories))
            }

            const obj = groupedFilters[displayGroup] ?? {}

            if (obj.groupName && obj.values.length > 0) {
                container.appendChild(createActiveFilterGroup(obj.groupName, `${displayGroup}:`, obj.values))
            }
        }

        // search text
        if (getSearchText()) container.appendChild(createActiveFilterGroup("suchtext", "Suchtext:", [getSearchText()]))

        // add delete all filter button
        if (container.children.length > 0) {
            container.appendChild(createActiveFilterDeleteAllButton())
            hideInfoStripe()
        } else {
            showInfoStripe()
        }

        const activeFilterBarContainer = activeFilterBarContainerElement()
        if (activeFilterBarContainer) {
            activeFilterBarContainer.innerHTML = ""
            activeFilterBarContainer.appendChild(container)
        }
    })
}

function onActiveFilterBarClick(event: MouseEvent) {
    const target = event.target as HTMLButtonElement
    const group = target.getAttribute("data-group") as string
    const value = target.getAttribute("data-value") as string
    const displayGroup = target.textContent?.replace(":", "") || ""
    resetPagination()

    // categories
    if (group === "rubrik") {
        value ? removeCategory(value) : setCategories([])
        updateFilterCategoryCheckboxes(getCategories())
        updateActiveFilterBarInDom()
        updateFilterTabsInDomMobile()
        fetchApiWithAllFiltersDebounced(afterFilterApiFetched)
        return
    }

    // searchtext
    if (group === "suchtext") {
        setSearchText("")
        updateSearchTextInDom()
        updateActiveFilterBarInDom()
        updateFilterTabsInDomMobile()
        fetchApiWithAllFiltersDebounced(afterFilterApiFetched)
        return
    }

    // filter values
    if (value) {
        // selects
        if (filterConfig.groups.select.includes(group)) {
            const parameters = getFilters()[group]
            if (parameters.includes("")) {
                removeFilterGroup(group)
            } else if (value === "von") {
                setFilterGroupValue(group, ["", parameters[1]])
            } else {
                setFilterGroupValue(group, [parameters[0], ""])
            }
        } else {
            // checkboxes
            removeFilterGroupValue(group, value)
        }
    } else if (group) {
        removeGroupedFilterGroup(displayGroup)
    }
    updateFilterCheckboxes(getFilters())
    updateActiveFilterBarInDom()
    updateFilterTabsInDomMobile()
    fetchApiWithAllFiltersDebounced(afterFilterApiFetched)
}

activeFilterBarContainerElement()?.addEventListener("click", onActiveFilterBarClick)
updateActiveFilterBarInDom()
